/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_LabelInputs */

const en_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Source`)
};

const fr_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source du media`)
};

const de_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienquelle`)
};

const it_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte multimediale`)
};

const ru_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источник информации`)
};

const es_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente de medios`)
};

const zh_cn2_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体来源`)
};

const ja_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアソース`)
};

const hi_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया स्रोत`)
};

const pt_pt2_media_import_source_label = /** @type {(inputs: Media_Import_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte de mídia`)
};

/**
* | output |
* | --- |
* | "Media Source" |
*
* @param {Media_Import_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_label = /** @type {((inputs?: Media_Import_Source_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_source_label(inputs)
	if (locale === "de") return de_media_import_source_label(inputs)
	if (locale === "it") return it_media_import_source_label(inputs)
	if (locale === "ru") return ru_media_import_source_label(inputs)
	if (locale === "es") return es_media_import_source_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_source_label(inputs)
	if (locale === "ja") return ja_media_import_source_label(inputs)
	if (locale === "hi") return hi_media_import_source_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_source_label(inputs)
	return en_media_import_source_label(inputs)
});